"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESTPropertiesFactoryFromJS = exports.RESTPropertiesFactory = void 0;
const immutable_1 = require("immutable");
const IREST_1 = require("../credentials/IREST");
exports.RESTPropertiesFactory = (0, immutable_1.Record)({
    credentials: (0, IREST_1.RESTCredentialsFactory)(),
    headers: (0, immutable_1.Map)(),
    authorizationType: 0 /* EAuthenticationTypes.NoAuth */,
    baseUrl: '',
    timeout: 60000
});
const RESTPropertiesFactoryFromJS = function (data) {
    return (0, exports.RESTPropertiesFactory)({
        credentials: (0, IREST_1.RESTCredentialsFactoryFromJS)(data.credentials),
        headers: (0, immutable_1.Map)(data.headers),
        authorizationType: data.authorizationType,
        baseUrl: data.baseUrl,
        timeout: data.timeout
    });
};
exports.RESTPropertiesFactoryFromJS = RESTPropertiesFactoryFromJS;
//# sourceMappingURL=IREST.js.map